import ManageUsersIdsModal from './ManageUsersIdsModal';

export default ManageUsersIdsModal;
